import React, { useState } from 'react';
import mixpanel from 'mixpanel-browser';
import { ExpandMore as ExpandMoreIcon } from '@mui/icons-material';
import { Accordion, AccordionSummary, AccordionDetails } from '@mui/material';

import {
  CAREER_INTERVIEW_HEADER,
  CAREER_INTERVIEW_SUBHEADER,
  CAREER_INTERVIEW_SECTION_LIST,
} from '../../constants/Careers';
import './InterviewProcess.css';

export const InterviewProcess = () => {
  const [expandedSections, setExpandedSections] = useState({});
  return (
    <div className="interview-container">
      <div className="interview-content">
        <h2 className="interview-header">{CAREER_INTERVIEW_HEADER}</h2>
        <h5 className="interview-sub-header">{CAREER_INTERVIEW_SUBHEADER}</h5>

        <div className="interview-list">
          {CAREER_INTERVIEW_SECTION_LIST.map((step) => (
            <Accordion
              sx={{
                '&:first-of-type': {
                  borderTopLeftRadius: '10px',
                  borderTopRightRadius: '10px',
                },
                '&:last-of-type': {
                  borderBottomLeftRadius: '10px',
                  borderBottomRightRadius: '10px',
                },
                '&.Mui-expanded': {
                  margin: '0 auto',
                },
                border: '1px solid black',
                p: '1.25rem',
                p: { xs: '.5rem', sm: '0.5rem' },
                width: { xs: 'initial', sm: '50%' },
                margin: '0 auto',
                borderRadius: '10px',
              }}
              expanded={expandedSections[step.title]}
              onChange={() => {
                setExpandedSections((prevState) => {
                  const copyPrevState = { ...prevState };
                  if (prevState[step.title]) {
                    delete copyPrevState[step.title];

                    mixpanel.track('Interview Process', {
                      stepTitle: step.title,
                      action: 'Close',
                      stepSubheader: step.subheader,
                    });

                    return copyPrevState;
                  }

                  mixpanel.track('Interview Process', {
                    stepTitle: step.title,
                    action: 'Open',
                    stepSubheader: step.subheader,
                  });

                  return {
                    ...copyPrevState,
                    [step.title]: step.title,
                  };
                });
              }}
              key={step.title}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1-content"
                className="interview-section-header"
                sx={{
                  '&.Mui-expanded': {
                    minHeight: '50px',
                  },
                }}
              >
                {step.title}
              </AccordionSummary>

              <AccordionDetails>
                <div className="interview-section-sub-header">{step.subheader}</div>
              </AccordionDetails>
            </Accordion>
          ))}
          {/* <div className="interview-section-divider" /> */}
        </div>
      </div>
    </div>
  );
};
